// extracted by mini-css-extract-plugin
var _1 = "16px";
var _2 = "--tether-available-height";
var _3 = "--tether-available-width";
var _4 = "--tether-offset-cross-axis";
var _5 = "--tether-offset-main-axis";
export { _1 as "boundaryPadding", _2 as "propertyAvailableHeight", _3 as "propertyAvailableWidth", _4 as "propertyOffsetCrossAxis", _5 as "propertyOffsetMainAxis" }
